import { Component, OnInit,Inject } from '@angular/core';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';

@Component({
  selector: 'app-regn-exam-data',
  templateUrl: './regn-exam-data.component.html',
  styleUrls: ['./regn-exam-data.component.scss']
})
export class RegnExamDataComponent implements OnInit {
  APIService: string;
  examData: any;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<RegnExamDataComponent>,
   private dialog: MatDialog,
     ) { this.APIService = environment.serviceUrl; }
     selectedRow: any | null = null;
  ngOnInit(): void {
    this.ExamData(this.data)
  }

  ExamData(data){
    this.examData = []
    this.spinner.show();
    const payload = {};
    payload['RgId'] = data.RgId
    payload['EmSrNo'] = ''
    payload['Order'] = ''
    payload['CoCode'] = data.RgCoCode
    payload['RgNo'] = data.RgNo
    payload['RgName'] = data.RgName
    this.umsService.SearchRegnExam(payload).subscribe((res) => {
      this.spinner.hide();
      this.examData = res.data
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.examData = []
    })
  }

  


  selected(data){
    this.selectedRow = data;
    sessionStorage.setItem('selectedRow',this.selectedRow)
  }

  openSub(){
    let data = {}
   data['data'] = this.examData;
    data['type'] = 'exam';
    const dialogRef = this.dialog.open(RegnExamSubComponent, {
      width: '130vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

}
